import React from 'react'

import { MobileFullScreenSheet } from '@/mobile/platform/MobileFullScreenSheet'

/** Sheet Nutrimatic — delega en MobileFullScreenSheet con clases nm-mobile-simple. */
export function MobileTokenPickerSheet({
  open,
  onClose,
  children,
  placement = 'fullscreen',
}: {
  open: boolean
  onClose: () => void
  children: React.ReactNode
  /** `embedded`: solo cubre el contenedor padre (panel trade desktop). */
  placement?: 'fullscreen' | 'embedded'
}) {
  return (
    <MobileFullScreenSheet
      open={open}
      onClose={onClose}
      inline={placement === 'embedded'}
      rootClassName="nm-mobile-simple__token-sheet-root"
      backdropClassName="nm-mobile-simple__token-sheet-backdrop"
      panelClassName="nm-mobile-simple__token-sheet-panel"
    >
      {children}
    </MobileFullScreenSheet>
  )
}
